import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import Properties from "../const/Properties";
import axios from 'axios';
import {withRouter} from 'react-router-dom';
import CustomTable from "../thema/tema1/component/CustomTable";


const active = {Home: "active"};
const bankalar = {
    0: "BELİRLENMEDİ",
    1: "ZİRAAT",
    2: "İŞ BANKASI"
};
const urunler = {
    0: "ÜRÜN SEÇ",
    1: "GEMİ ÜCRETİ",
    2: "UÇAK ÜCRETİ",
    3: "ETS",
    4: "EK SÜRÜCÜ",
    5: "YANICI",
    6: "SİGORTA",
    7: "YOL GEÇİŞ ÜCRETİ",
    8: "ENS",
    9: "BAF",
    10: "ŞOFÖR ÜCRETİ",
    11: "XRAY",
    12: "REZERVASYON ÜCRETİ",
    13: "LİMAN ÜCRETİ",
    14: "FORKLİFT ÜCRETİ",
};
class FaturaBelirleme extends React.Component {
    constructor(props) {
        super(props);
        //alert(this.props.match.params.id);
        this.state = {
            tasimaId: this.props.match.params.id,
            odemeTuru: 0,
            odemeUcreti: 0,
            firmalar: [],
            muhasebefirmalar: [],
            content: [],
            pageCount: 0,
            gemiUcreti: false,
            gemiUcretiFirma: 0,
            gemiUcretiOdeme: 0,
            gemiUcretiMuhasebe: 0,
            gemiUcretiFaturaNumarasi: "",
            baf: false,
            bafFirma: 0,
            bafOdeme: 0,
            bafMuhasebe: 0,
            bafFaturaNumarasi: "",
            ets: false,
            etsFirma: 0,
            etsOdeme: 0,
            etsMuhasebe: 0,
            etsFaturaNumarasi: "",
            liman: false,
            limanFirma: 0,
            limanOdeme: 0,
            limanFaturaNumarasi: "",
            soforUcreti: 0,
            soforUcretiFirma: 0,
            soforUcretiOdeme: 0,
            soforUcretiMuhasebe: 0,
            soforUcretiFaturaNumarasi: "",
            ekSofor: 0,
            ekSoforFirma: 0,
            ekSoforOdeme: 0,
            ekSoforMuhasebe: 0,
            ekSoforFaturaNumarasi: "",
            xray: false,
            xrayFirma: 0,
            xrayOdeme: 0,
            xrayMuhasebe: 0,
            xrayFaturaNumarasi: "",
            yanici: false,
            yaniciFirma: 0,
            yaniciOdeme: 0,
            yaniciMuhasebe: 0,
            yaniciFaturaNumarasi: "",
            rezervasyon: false,
            rezervasyonFirma: 0,
            rezervasyonOdeme: 0,
            rezervasyonMuhasebe: 0,
            rezervasyonFaturaNumarasi: "",
            forklift: 0,
            forkliftFirma: 0,
            forkliftOdeme: 0,
            forkliftMuhasebe: 0,
            forkliftFaturaNumarasi: "",
            ardiye: 0,
            ardiyeFirma: 0,
            ardiyeOdeme: 0,
            ardiyeFaturaNumarasi: "",
            yolGecisUcreti: 0,
            yolGecisUcretiFirma: 0,
            yolGecisUcretiOdeme: 0,
            yolGecisUcretiMuhasebe: 0,
            yolGecisUcretiFaturaNumarasi: "",
            sigorta: 0,
            sigortaFirma: 0,
            sigortaOdeme: 0,
            sigortaFaturaNumarasi: "",
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            silModal: 'none',
            title: ["ÖDEME TURU", "ÖDEME ÜCRETİ", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            ens: false,
            ensMuhasebe: false,
            ensFaturaNumarasi: "",
            ensFirma: "",
            toplam: 0,
            error: 0
        };
        this.firmalarDoldur();
        this.muhasebefirmalarDoldur();
        this.get();
    }
    muhasebefirmalarDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/muhasebefirma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let muhasebefirmalar = res.data.map((item) =>
                    <option value={item.id}>{item.firmaAdi}</option>);
                this.setState({muhasebefirmalar: muhasebefirmalar});
            })
    }
    componentDidMount() {

    }

    geri = (e) => {
        window.location = document.referrer;
    }
    firmalarDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/firma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let firmalar = res.data.map((item) =>
                    <option value={item.id}>{item.firmaAdi}</option>);
                this.setState({firmalar: firmalar});
            })
    }
    get = e => {
        let status = true;
        if (status) {

            axios({
                method: 'get',
                url: Properties.baseUrl + '/ucretbelirle/get/' + this.state.tasimaId,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            })
                .then(res => {
                    this.setState({gemiUcreti: res.data.gemiUcreti});
                    this.setState({gemiUcretiFirma: res.data.gemiUcretiFirma});
                    this.setState({gemiUcretiOdeme: res.data.gemiUcretiOdeme});
                    this.setState({gemiUcretiMuhasebe: res.data.gemiUcretiMuhasebe});
                    this.setState({gemiUcretiFaturaNumarasi: res.data.gemiUcretiFaturaNumarasi});
                    this.setState({baf: res.data.baf});
                    this.setState({bafFirma: res.data.bafFirma});
                    this.setState({bafOdeme: res.data.bafOdeme});
                    this.setState({bafMuhasebe: res.data.bafMuhasebe});
                    this.setState({bafFaturaNumarasi: res.data.bafFaturaNumarasi});
                    this.setState({ets: res.data.ets});
                    this.setState({etsFirma: res.data.etsFirma});
                    this.setState({etsOdeme: res.data.etsOdeme});
                    this.setState({etsMuhasebe: res.data.etsMuhasebe});
                    this.setState({etsFaturaNumarasi: res.data.etsFaturaNumarasi});
                    this.setState({liman: res.data.liman});
                    this.setState({limanFirma: res.data.limanFirma});
                    this.setState({limanOdeme: res.data.limanOdeme});
                    this.setState({limanMuhasebe: res.data.limanMuhasebe});
                    this.setState({limanFaturaNumarasi: res.data.limanFaturaNumarasi});
                    this.setState({soforUcreti: res.data.soforUcreti});
                    this.setState({soforUcretiFirma: res.data.soforUcretiFirma});
                    this.setState({soforUcretiOdeme: res.data.soforUcretiOdeme});
                    this.setState({soforUcretiMuhasebe: res.data.soforUcretiMuhasebe});
                    this.setState({soforUcretiFaturaNumarasi: res.data.soforUcretiFaturaNumarasi});
                    this.setState({ekSofor: res.data.ekSofor});
                    this.setState({ekSoforFirma: res.data.ekSoforFirma});
                    this.setState({ekSoforOdeme: res.data.ekSoforOdeme});
                    this.setState({ekSoforMuhasebe: res.data.ekSoforMuhasebe});
                    this.setState({ekSoforFaturaNumarasi: res.data.ekSoforFaturaNumarasi});
                    this.setState({xray: res.data.xray});
                    this.setState({xrayFirma: res.data.xrayFirma});
                    this.setState({xrayOdeme: res.data.xrayOdeme});
                    this.setState({xrayMuhasebe: res.data.xrayMuhasebe});
                    this.setState({xrayFaturaNumarasi: res.data.xrayFaturaNumarasi});
                    this.setState({yanici: res.data.yanici});
                    this.setState({yaniciFirma: res.data.yaniciFirma});
                    this.setState({yaniciOdeme: res.data.yaniciOdeme});
                    this.setState({yaniciMuhasebe: res.data.yaniciMuhasebe});
                    this.setState({yaniciFaturaNumarasi: res.data.yaniciFaturaNumarasi});
                    this.setState({rezervasyon: res.data.rezervasyon});
                    this.setState({rezervasyonFirma: res.data.rezervasyonFirma});
                    this.setState({rezervasyonOdeme: res.data.rezervasyonOdeme});
                    this.setState({rezervasyonMuhasebe: res.data.rezervasyonMuhasebe});
                    this.setState({rezervasyonFaturaNumarasi: res.data.rezervasyonFaturaNumarasi});
                    this.setState({forklift: res.data.forklift});
                    this.setState({forkliftFirma: res.data.forkliftFirma});
                    this.setState({forkliftOdeme: res.data.forkliftOdeme});
                    this.setState({forkliftMuhasebe: res.data.forkliftMuhasebe});
                    this.setState({forkliftFaturaNumarasi: res.data.forkliftFaturaNumarasi});
                    this.setState({ardiye: res.data.ardiye});
                    this.setState({ardiyeFirma: res.data.ardiyeFirma});
                    this.setState({ardiyeOdeme: res.data.ardiyeOdeme});
                    this.setState({ardiyeMuhasebe: res.data.ardiyeMuhasebe});
                    this.setState({ardiyeFaturaNumarasi: res.data.ardiyeFaturaNumarasi});
                    this.setState({yolGecisUcreti: res.data.yolGecisUcreti});
                    this.setState({yolGecisUcretiFirma: res.data.yolGecisUcretiFirma});
                    this.setState({yolGecisUcretiOdeme: res.data.yolGecisUcretiOdeme});
                    this.setState({yolGecisUcretiMuhasebe: res.data.yolGecisUcretiMuhasebe});
                    this.setState({yolGecisUcretiFaturaNumarasi: res.data.yolGecisUcretiFaturaNumarasi});
                    this.setState({sigorta: res.data.sigorta});
                    this.setState({sigortaFirma: res.data.sigortaFirma});
                    this.setState({sigortaOdeme: res.data.sigortaOdeme});
                    this.setState({sigortaMuhasebe: res.data.sigortaMuhasebe});
                    this.setState({sigortaFaturaNumarasi: res.data.sigortaFaturaNumarasi});
                    this.setState({ens: res.data.ens});
                    this.setState({ensMuhasebe: res.data.ensMuhasebe});
                    this.setState({ensFaturaNumarasi: res.data.ensFaturaNumarasi});
                    this.setState({ensFirma: res.data.ensFirma});
                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Ek Bilgi Güncellenemedi." : "Ek Bilgi Kaydedilemedi."));
            });
        }
    }
    onChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }
    ucretBelirleSave = e => {
        let status = true;
        if (status) {
            axios({
                method: 'post',
                url: Properties.baseUrl + '/ucretbelirle/faturabelirleme',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                data: {
                    tasimaId: this.state.tasimaId,
                    gemiUcretiFirma: this.state.gemiUcretiFirma,
                    gemiUcretiMuhasebe: this.state.gemiUcretiMuhasebe,
                    gemiUcretiFaturaNumarasi: this.state.gemiUcretiFaturaNumarasi,
                    bafFirma: this.state.bafFirma,
                    bafMuhasebe: this.state.bafMuhasebe,
                    bafFaturaNumarasi: this.state.bafFaturaNumarasi,
                    etsFirma: this.state.etsFirma,
                    etsMuhasebe: this.state.etsMuhasebe,
                    etsFaturaNumarasi: this.state.etsFaturaNumarasi,
                    limanFirma: this.state.limanFirma,
                    limanMuhasebe: this.state.limanMuhasebe,
                    limanFaturaNumarasi: this.state.limanFaturaNumarasi,
                    soforUcretiFirma: this.state.soforUcretiFirma,
                    soforUcretiMuhasebe: this.state.soforUcretiMuhasebe,
                    soforUcretiFaturaNumarasi: this.state.soforUcretiFaturaNumarasi,
                    ekSoforFirma: this.state.ekSoforFirma,
                    ekSoforMuhasebe: this.state.ekSoforMuhasebe,
                    ekSoforFaturaNumarasi: this.state.ekSoforFaturaNumarasi,
                    xrayFirma: this.state.xrayFirma,
                    xrayMuhasebe: this.state.xrayMuhasebe,
                    xrayFaturaNumarasi: this.state.xrayFaturaNumarasi,
                    yaniciFirma: this.state.yaniciFirma,
                    yaniciMuhasebe: this.state.yaniciMuhasebe,
                    yaniciFaturaNumarasi: this.state.yaniciFaturaNumarasi,
                    rezervasyonFirma: this.state.rezervasyonFirma,
                    rezervasyonMuhasebe: this.state.rezervasyonMuhasebe,
                    rezervasyonFaturaNumarasi: this.state.rezervasyonFaturaNumarasi,
                    forkliftFirma: this.state.forkliftFirma,
                    forkliftMuhasebe: this.state.forkliftMuhasebe,
                    forkliftFaturaNumarasi: this.state.forkliftFaturaNumarasi,
                    ardiyeFirma: this.state.ardiyeFirma,
                    ardiyeMuhasebe: this.state.ardiyeMuhasebe,
                    ardiyeFaturaNumarasi: this.state.ardiyeFaturaNumarasi,
                    yolGecisUcretiFirma: this.state.yolGecisUcretiFirma,
                    yolGecisUcretiMuhasebe: this.state.yolGecisUcretiMuhasebe,
                    yolGecisUcretiFaturaNumarasi: this.state.yolGecisUcretiFaturaNumarasi,
                    sigortaFirma: this.state.sigortaFirma,
                    sigortaMuhasebe: this.state.sigortaMuhasebe,
                    sigortaFaturaNumarasi: this.state.sigortaFaturaNumarasi,
                    ensMuhasebe: this.state.ensMuhasebe,
                    ensFaturaNumarasi: this.state.ensFaturaNumarasi,
                    ensFirma: this.state.ensFirma,
                }
            })
                .then(res => {
                    window.successful((this.state.showDuzenle ? "Ücret Belirle Güncellendi." : "Ücret Belirle  Kaydedildi"));
                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Ücret Belirle  Güncellenemedi." : "Ücret Belirle  Kaydedilemedi."));
            });
            this.geri();
        }
    }
    faturaSave = e => {
        let status = true;
        if (status) {
            axios({
                method: 'post',
                url: Properties.baseUrl + '/fatura/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                data: {
                    plaka: this.state.plaka ? this.state.plaka.toUpperCase().replace(/\s/g, '') : '',
                    firmaId: this.state.firmaId ? this.state.firmaId : 0,
                    tasimaId: this.state.tasimaId ? this.state.tasimaId : 0,
                    urunId: this.state.urunId ? this.state.urunId : 0,
                    bankaId: this.state.bankaId ? this.state.bankaId : 0,
                    faturaNumarasi: this.state.faturaNumarasi ? this.state.faturaNumarasi : "",
                    tutar: this.state.tutar ? this.state.tutar : 0,
                }
            })
                .then(res => {
                    window.successful((this.state.showDuzenle ? "Fatura Güncellendi." : "Fatura Kaydedildi"));
                    this.cikis();
                }).catch(res => {
            });
        }
    }
    getTotalRow = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/firma/toplam/',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.setState({totalRow:res.data});
                this.setState({pageCount:res.data/10});
            });
    }
    handlePageClick=e=>{
        this.setState({ startRow: (e.selected*10)+1});
        this.setState({ endRow:((e.selected+1)*10)});
        axios({
            method: 'get',
            url: Properties.baseUrl+'/firma/sayfaliGetir/'+e.selected,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.firmaAdi = eleman.firmaAdi;
                    elemanIc.firmaTelefon = eleman.firmaTelefon;
                    elemanIc.firmaAdres = eleman.firmaAdres;
                    getData.push(eleman);
                });
                this.setState({firmalar:getData});
                let content = getData.map((item) =>
                    (<tr>
                        <td>{item.firmaAdi}</td>
                        <td>{item.firmaTelefon}</td>
                        <td>{item.firmaAdres}</td>
                        <td>
                            <div className="row">
                                <div className="col-3">
                                    <button type="button" onClick={e => this.setDuzenle(item)}
                                            className="btn btn-block btn-outline-info">DÜZENLE
                                    </button>
                                </div>
                                <div className="col-2">
                                    <button type="button" className="btn btn-block btn-outline-danger"
                                            onClick={e => this.setSil(item)} data-toggle="modal"
                                            data-target="#modal-default">SİL
                                    </button>

                                </div>
                            </div>

                        </td>
                    </tr>));
                this.setState({content: content});
            });
    }
    render() {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu/>
                <PageContext>
                    <form>
                        <div className="card card-primary">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-2">
                                        <h3 className="card-title">Fatura Girişi</h3>
                                    </div>
                                </div>

                            </div>
                            <div className="card-body">
                                <div className="col-12">
                                    <label htmlFor="exampleInputEmail1">Plaka</label>
                                    <input disabled type="text" className="form-control" name="plaka"
                                           onChange={this.onChange} value={this.state.plaka}
                                           placeholder="Plaka"/>
                                </div>
                                <div className="col-12">
                                    <label>Ürün Adı</label>
                                    <select name="urunId" className="form-control select2"
                                            onChange={this.onChange} value={this.state.urunId}>
                                        {Object.entries(urunler).map(([key, value]) => (
                                            <option key={key} value={key}>
                                                {value}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-12">
                                    <label>Firma Adı</label>
                                    <select name="firmaId" className="form-control select2"
                                            onChange={this.onChange} value={this.state.firmaId}>
                                        {this.state.firmalar}
                                    </select>
                                </div>
                                <div className="col-12">
                                    <label>Banka Adı</label>
                                    <select name="bankaId" className="form-control select2"
                                            onChange={this.onChange} value={this.state.bankaId}>
                                        {Object.entries(bankalar).map(([key, value]) => (
                                            <option key={key} value={key}>
                                                {value}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="exampleInputEmail1">Fatura Numarası</label>
                                    <input type="text" className="form-control" name="faturaNumarasi"
                                           onChange={this.onChange} value={this.state.faturaNumarasi}
                                           placeholder="Fatura Numarası"/>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="exampleInputEmail1">Tutar</label>
                                    <input type="text" className="form-control" name="tutar"
                                           onChange={this.onChange} value={this.state.tutar}
                                           placeholder="Tutar"/>
                                </div>
                                <div className=" row">
                                    <div className="col-6">
                                        <button type="button"
                                                onClick={this.save}
                                                className="btn btn-block btn-primary">Kaydet
                                        </button>
                                    </div>
                                    <div className="col-6">
                                        <button type="button" onClick={e => this.cikis(e)}
                                                className="btn btn-block btn-outline-info">Temizle
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="card-footer row"></div>
                            <div className="card-footer row">
                                <div className="col-1">
                                    <button type="button" onClick={e => this.geri(e)}
                                            className="btn btn-block btn-outline-info">GERİ
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                <CustomTable state={this.state} getTotalRow={this.getTotalRow}
                                             handlePageClick={this.handlePageClick}></CustomTable>
                            </div>
                        </div>
                    </form>
                </PageContext>
                <Footer/>
            </div>);
    }
}


export default withRouter(FaturaBelirleme);
